<script>
import Icon from 'dashboard/components-next/icon/Icon.vue';

export default Icon;
</script>
